import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClienteService } from '@core/services/cliente.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FechamentoService } from 'app/services/fechamento.service';
import { TipoItemService } from '@core/services/tipo-item.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-detalhamento-fechamento',
  templateUrl: './detalhamento-fechamento.component.html',
  styleUrls: ['./detalhamento-fechamento.component.scss']
})
export class DetalhamentoFechamentoComponent implements OnInit {
  contentHeader: object;
  rows_chips: Array<any> | any = [];
  temp_chips: Array<any> | any = [];
  rows_veiculos: Array<any> | any = [];
  temp_veiculos: Array<any> | any = [];
  rows_vendas: Array<any> | any = [];
  rows_vendas_faleflex: Array<any> | any = []; 
  temp_vendas: Array<any> | any = [];
  rows_faleflex: Array<any> | any = [];
  temp_faleflex: Array<any> | any = [];
  rows_cliente: Array<any> | any = [];
  temp_cliente: Array<any> | any = [];
  href: any;
  routeLink: any;
  idFechamento: any;
  idCliente: any;
  resultado_importacao: any[];
  resultado_show: boolean;
  rows_iccid: any;
  temp_iccid: any;
  loading: boolean;
  starting: boolean = false;
  spinnerImportar = false;
  spinnerImportarBoleto = false;
  spinnerRelatorioCdr = false;
  spinnerImportarDadosBoleto = false;
  flgChip: any;
  flgTeste: any;
  flgVeiculos: any;
  Cliente: any;
  tipoItemServico: any[] = [];
  availableServicosFaleflex: any[] = [];
  novoFaleflex = { id_servico: null as any, quantidade: 1, tarifa_venda: 0, preco_total: 0 };
  isEditingFaleflex = false;
  editingFaleflexItem: any = null;

  constructor(
    private route: ActivatedRoute,
    private fechamentoService: FechamentoService,
    private clienteService: ClienteService,
    private modalService: NgbModal,
    private _router: Router,
    private tipoItemService: TipoItemService,
  
  ) { }

  ngOnInit(): void {
    this.href = this.route.url;
    this.routeLink = this.href.value[0].path
    this.idFechamento = this.href.value[1].path
    this.idCliente = this.href.value[3].path

    this.contentHeader = {
      headerTitle: "Detalhamento Final",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Início",
            isLink: false,
          },
          {
            name: "fechamento",
            isLink: false,
          },
          {
            name: "detalhamento final",
            isLink: false,
          },
        ],
      },
    };

    this.clienteService.getOne(this.idCliente).subscribe(
      async (resCliente) => {
        this.Cliente = { "id_cliente": resCliente.id_cliente, "email_cliente": resCliente.email_cliente, "razao_social": resCliente.razao_social, "nome_fantasia": resCliente.nome_fantasia, "cpf_cnpj_cliente":  resCliente.cpf_cnpj_cliente }
        console.log(this.Cliente);
        this.rows_cliente = resCliente;
        this.temp_cliente = resCliente;
      },
      (err) => {
        console.log(err);
      }
    );

    this.fechamentoService.getFechamentoVeiculoFinal(this.idFechamento, this.idCliente).subscribe(
      (res) => {
        if (res.data.length > 0 && res.statusCode == 200) {
          (this.rows_veiculos = res.data), (this.temp_veiculos = res.data);
          this.flgVeiculos = this.rows_veiculos[0].flg_veiculos
        }
      },
      (error) => {
        console.log(error);
      }
    );

    this.fechamentoService.getFechamentoChipFinal(this.idFechamento, this.idCliente).subscribe(
      (res) => {
        if (res.data.length > 0 && res.statusCode == 200) {
          (this.rows_chips = res.data), (this.temp_chips = res.data);
          this.flgChip = this.rows_chips[0].flg_chip
          this.flgTeste = this.rows_chips[0].flg_teste
        }
      },
      (error) => {
        console.log(error);
      }
    );

    this.fechamentoService.getFechamentoFaleFlexFinal(this.idFechamento, this.idCliente).subscribe(
      (res) => {
        if (res.data.length > 0 && res.statusCode == 200) {
          (this.rows_faleflex = res.data), (this.temp_faleflex = res.data);
          // this.flgChip = this.rows_faleflex[0].flg_chip
          this.flgTeste = this.rows_faleflex[0].flg_teste
          this.updateAvailableServicosFaleflex();
        }
      },
      (error) => {
        console.log(error);
      }
    );

    this.fechamentoService.getIccdsFechamento(this.idFechamento, this.idCliente).subscribe(
      (res) => {
        if (res.data.length > 0 && res.statusCode == 200) {
          (this.rows_iccid = res.data), (this.temp_iccid = res.data);
        }
      },
      (error) => {
        console.log(error);
      }
    );

    this.fechamentoService.getVendas(this.idFechamento, this.idCliente, 2).subscribe(
      (res) => {
        if (res.data.length > 0 && res.statusCode == 200) {
          (this.rows_vendas = res.data[0]), (this.temp_vendas = res.data[0]);
        }
      },
      (error) => {
        console.log(error);
      }
    );

    this.fechamentoService.getVendas(this.idFechamento, this.idCliente, 3).subscribe(
      (res) => {
        if (res.data.length > 0 && res.statusCode == 200) {
          (this.rows_vendas_faleflex = res.data[0]), (this.temp_vendas = res.data[0]);
        }
      },
      (error) => {
        console.log(error);
      }
    );

    this.tipoItemService.getServicoEmpresa(3).subscribe(
      (res) => {
        if (res.data.length > 0) {
          this.tipoItemServico = res.data;
          this.updateAvailableServicosFaleflex();
        }
      },
      (error) => {
        console.log(error);
      }
    );

    // this.clienteService.getOne(this.idCliente).subscribe(
    //   (res) => {
    //     if (res !== null) {
    //       (this.rows_cliente = res), (this.temp_cliente = res);
    //     }
    //   },
    //   (error) => {
    //     console.log(error);
    //   }
    // );
  }

  modalChips(modal, pOperadora) {
    const temp = this.temp_iccid.filter(function (d) {
      if (d['operadora'] != null) return d['operadora'].toLowerCase().indexOf(pOperadora.toLowerCase()) !== -1 || !pOperadora.toLowerCase();
    });
    console.log(pOperadora);
    // update the rows
    this.rows_iccid = temp;

    const modalRef = this.modalService.open(modal, {
      windowClass: 'modal',
      size: 'xl',
      centered: true
    });

    modalRef.result.then(
      (result) => {
        this.resultado_importacao = [];
        this.resultado_show = false;
      },
      (reason) => {
        this.resultado_importacao = [];
        this.resultado_show = false;
      }
    );
  }

  textFilterVeiculo(event, param) {
    const val = event.target.value.toLowerCase();
    // filter our data
    const temp = this.temp_veiculos.filter(function (d) {
      if (d[param] != null) return d[param].toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows

    this.rows_veiculos = temp;
    // Whenever the filter changes, always go back to the first page
    // this.table.offset = 0;
  }

  textFilterChips(event, param) {
    const val = event.target.value.toLowerCase();
    // filter our data
    const temp = this.temp_iccid.filter(function (d) {
      if (d[param] != null) return d[param].toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows

    this.rows_iccid = temp;
    // Whenever the filter changes, always go back to the first page
    // this.table.offset = 0;
  }

  msgErroInterno() {
    this.starting = false;
    this.loading = false;
    Swal.fire({
      title: "Erro!",
      text: "Ocorreu um erro interno.",
      icon: "error",
      confirmButtonText: "Confirmar",
      confirmButtonColor: '#ef6767',
    });
  }

  msgErroInternoExisting() {
    this.starting = false;
    this.loading = false;
    Swal.fire({
      title: "Erro!",
      text: "Já existe uma venda gerada!",
      icon: "error",
      confirmButtonText: "Confirmar",
      confirmButtonColor: '#ef6767',
    });
  }

  sendBoleto(event, param) {
    Swal.fire({
      title: "Confirmação",
      text: "Deseja gerar venda?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: '#161D31',
      cancelButtonColor: '#6e7d88',
      confirmButtonText: 'Confirmar',
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Aguarde",
          text: "Estamos gerando a venda. Isso pode levar alguns instantes.",
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        Swal.showLoading(); 
  
        this.fechamentoService.postGerarVenda(this.idCliente, this.idFechamento).subscribe(
          (res) => {
            Swal.close();
            console.log(res);
  
            if (res.statusCode === 201) {
              Swal.fire({
                title: "Venda gerada!",
                text: "A venda foi gerada com sucesso.",
                icon: "success",
                confirmButtonText: "Confirmar",
                confirmButtonColor: '#161D31',
              }).then(() => {
                this.spinnerImportar = false;
              });
            } else {
              this.msgErroInternoExisting();
            }
          },
          (error) => {
            console.log(error);
            Swal.close(); 
            this.spinnerImportar = false;
            this.msgErroInterno();
          }
        );
      }
    });
  }
  

  sendBoletoOne(event, param) {
    Swal.fire({
      title: "Confirmação",
      text: "Deseja reenviar boleto?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: '#161D31',
      cancelButtonColor: '#6e7d88',
      confirmButtonText: 'Confirmar',
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Aguarde",
          text: "Estamos reenviando o boleto. Isso pode levar alguns instantes.",
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        Swal.showLoading(); 
  
        this.fechamentoService.postEnviarBoleto(this.idCliente, this.idFechamento).subscribe(
          (res) => {
            Swal.close(); 
            console.log(res);
  
            if (res.statusCode === 201) {
              Swal.fire({
                title: "Boleto reenviado!",
                text: "O boleto foi enviado com sucesso.",
                icon: "success",
                confirmButtonText: "Confirmar",
                confirmButtonColor: '#161D31',
              }).then(() => {
                this.spinnerImportarBoleto = false;
              });
            } else {
              this.msgErroInterno();
            }
          },
          (error) => {
            console.log(error);
            Swal.close(); 
            this.spinnerImportarBoleto = false;
            this.msgErroInterno();
          }
        );
      }
    });
  }
  

  // shareByWhatsApp(event, param) {
  //   Swal.fire({
  //     title: "Confirmação",
  //     text: "Deseja reenviar boleto?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: '#161D31',
  //     cancelButtonColor: '#6e7d88',
  //     confirmButtonText: 'Confirmar',
  //     cancelButtonText: "Cancelar"
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       this.spinnerImportarBoleto = true;

  //       this.fechamentoService.postEnviarBoletoWpp(this.idCliente, this.idFechamento).subscribe(
  //         (res) => {
  //           console.log(res);

  //           if (res.statusCode == 201) {
  //             this.loading = false;
  //             Swal.fire({
  //               title: "Boleto reenviado!",
  //               text: "O boleto foi enviado com sucesso.",
  //               icon: "success",
  //               confirmButtonText: "Confirmar",
  //               confirmButtonColor: '#161D31',
  //             }).then(() => {
  //               this.spinnerImportarBoleto = false;
  //             });
  //           } else {
  //             this.msgErroInterno()
  //           }
  //         },
  //         (error) => {
  //           console.log(error);
  //           this.spinnerImportarBoleto = false;
  //           this.msgErroInterno()
  //         }
  //       );
  //     }
  //   })
  // } 
  shareByWhatsApp(idCliente: string, idFechamento: string) {
    Swal.fire({
      title: "Confirmação",
      text: "Deseja reenviar boleto?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: '#161D31',
      cancelButtonColor: '#6e7d88',
      confirmButtonText: 'Confirmar',
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinnerImportarBoleto = true;

        this.fechamentoService.postEnviarBoletoWpp(idCliente, idFechamento).subscribe(
          (res) => {
            if (res.statusCode === 201) {
              const boletoLink = res.data.banking_billet.pdf || '';
              const pixCode = res.data.banking_billet.pix || '';
              const valor = res.data.total || '';
              const vencimento = res.data.data_vencimento || '';
              let formattedDate = '';
              if (vencimento) {
                const [year, month, day] = vencimento.split('-');
                const date = new Date(Number(year), Number(month) - 1, Number(day)); 
                const dayFormatted = String(date.getDate()).padStart(2, '0');
                const monthFormatted = String(date.getMonth() + 1).padStart(2, '0');
                const yearFormatted = date.getFullYear();
                formattedDate = `${dayFormatted}/${monthFormatted}/${yearFormatted}`;
              }
              const empresa = "Rastreei Sistema de Monitoramento e Telemetria Veicular";
              const numeroDestinatario = res.data.telefone_financeiro || '';

              const message = `
                Olá, segue o boleto no valor de *R$ ${valor}*. Emitido por ${empresa}, com vencimento para *${formattedDate}*. Acesse o boleto pelo link: ${boletoLink} ou pague usando o Pix Copia e Cola: ${pixCode}
              `;

              const encodedMessage = encodeURIComponent(message.trim());
              const whatsappUrl = `https://wa.me/55` + `${numeroDestinatario}?text=${encodedMessage}`;

              window.open(whatsappUrl, '_blank');

              this.spinnerImportarBoleto = false;
            } else {
              this.msgErroInterno();
            }
          },
          (error) => {
            console.error(error);
            this.spinnerImportarBoleto = false;
            this.msgErroInterno();
          }
        );
      }
    });
  }

  isCompartilharDisabled(): boolean {
    const situacao = this.rows_vendas?.id_situacao_venda;
    return situacao === '3' || situacao === '6' || situacao === '8';
  }

  isvendaDisabled(): boolean {
    if (this.rows_veiculos.length == 0 && this.rows_chips.length == 0) {
      return true;
    }
    const situacao = this.rows_vendas?.id_situacao_venda;
    const idVenda = this.rows_vendas?.id_venda !== undefined ? this.rows_vendas?.id_venda : null;

    // Se existir venda porém estiver com status de cancelada
    if (idVenda !== null && situacao === '0') {
      return false;
    }

    // Se existir venda e os status forem de pagas
    return situacao === '3' || situacao === '6' || situacao === '8' || idVenda !== null;
  }

  isvendaDisabledFaleFlex(): boolean {
    if (this.rows_faleflex.length == 0) {
      return true;
    }
    const situacao = this.rows_vendas_faleflex?.id_situacao_venda;
    const idVenda = this.rows_vendas_faleflex?.id_venda !== undefined ? this.rows_vendas?.id_venda : null;

    // Se existir venda porém estiver com status de cancelada
    if (idVenda !== null && situacao === '0') {
      return false;
    }
    

    // Se existir venda e os status forem de pagas
    return situacao === '3' || situacao === '6' || situacao === '8' || idVenda !== null;
  }

  updateAvailableServicosFaleflex() {
    const nomes = new Set((this.rows_faleflex || []).map((r: any) => String(r.nome).toLowerCase()));
    if (this.isEditingFaleflex && this.editingFaleflexItem?.nome) {
      nomes.delete(String(this.editingFaleflexItem.nome).toLowerCase());
    }
    this.availableServicosFaleflex = (this.tipoItemServico || []).filter((s: any) => !nomes.has(String(s.nome).toLowerCase()));
    if (this.availableServicosFaleflex.length > 0) {
      const exists = this.availableServicosFaleflex.some((s: any) => s.id_servico === this.novoFaleflex.id_servico);
      if (!exists) {
        this.novoFaleflex.id_servico = this.availableServicosFaleflex[0].id_servico;
      }
    }
  }

  openModalFaleflex(modal: any) {
    this.updateAvailableServicosFaleflex();
    const modalRef = this.modalService.open(modal, {
      windowClass: 'modal',
      size: 'lg',
      centered: true
    });
    modalRef.result.then(
      () => {},
      () => {}
    );
  }

  onChangeFaleflex() {
    const q = Number(this.novoFaleflex.quantidade) || 0;
    const v = Number(this.novoFaleflex.tarifa_venda) || 0;
    this.novoFaleflex.preco_total = q * v;
  }

  addFaleflexItem() {
    const selected = (this.tipoItemServico || []).find((s: any) => s.id_servico === this.novoFaleflex.id_servico);
    if (!selected) return;
    const payload = {
      nome: selected.nome,
      quantidade: Number(this.novoFaleflex.quantidade) || 0,
      tarifa_venda: Number(this.novoFaleflex.tarifa_venda) || 0,
      preco_total: Number(this.novoFaleflex.preco_total) || 0
    };

    Swal.fire({
      title: "Aguarde",
      text: this.isEditingFaleflex ? "Estamos atualizando o item." : "Estamos adicionando o item.",
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
    Swal.showLoading();

    if (this.isEditingFaleflex && this.editingFaleflexItem?.id_fechamento_faleflex_final) {
      this.fechamentoService.patchFechamentoFaleflexItem(this.editingFaleflexItem.id_fechamento_faleflex_final, payload).subscribe(
        (res) => {
          Swal.close();
          if (res.statusCode === 200) {
            const idx = this.rows_faleflex.findIndex((r: any) => r.id_fechamento_faleflex_final === this.editingFaleflexItem.id_fechamento_faleflex_final);
            if (idx > -1) {
              this.rows_faleflex[idx] = { ...this.rows_faleflex[idx], ...payload, id_servico: this.novoFaleflex.id_servico };
              this.rows_faleflex = [...this.rows_faleflex];
              this.temp_faleflex = this.rows_faleflex;
            }
            this.isEditingFaleflex = false;
            this.editingFaleflexItem = null;
            this.modalService.dismissAll();
            this.updateAvailableServicosFaleflex();
            Swal.fire({
              title: "Item atualizado!",
              text: "O item foi alterado com sucesso.",
              icon: "success",
              confirmButtonText: "Ok",
              confirmButtonColor: '#161D31',
            });
          } else {
            this.msgErroInterno();
          }
        },
        (error) => {
          console.error(error);
          Swal.close();
          this.msgErroInterno();
        }
      );
    } else {
      this.fechamentoService.postFechamentoFaleflexItem(this.idCliente, this.idFechamento, this.novoFaleflex.id_servico, payload).subscribe(
        (res) => {
          Swal.close();
          if (res.statusCode === 201 || res.statusCode === 200) {
            const insertedId = res?.data?.id_fechamento_faleflex_final;
            const row = { id_fechamento_faleflex_final: insertedId, id_servico: this.novoFaleflex.id_servico, ...payload };
            this.rows_faleflex = [...this.rows_faleflex, row];
            this.temp_faleflex = this.rows_faleflex;
            this.modalService.dismissAll();
            this.updateAvailableServicosFaleflex();
            Swal.fire({
              title: "Item adicionado!",
              text: "O item foi incluído com sucesso.",
              icon: "success",
              confirmButtonText: "Ok",
              confirmButtonColor: '#161D31',
            });
          } else {
            this.msgErroInterno();
          }
        },
        (error) => {
          console.error(error);
          Swal.close();
          this.msgErroInterno();
        }
      );
    }
  }

  editFaleflex(row: any, modalRef: any) {
    this.isEditingFaleflex = true;
    this.editingFaleflexItem = row;
    this.novoFaleflex = {
      id_servico: row.id_servico ?? (this.tipoItemServico.find((s: any) => s.nome === row.nome)?.id_servico),
      quantidade: row.quantidade,
      tarifa_venda: row.tarifa_venda,
      preco_total: row.preco_total
    };
    this.openModalFaleflex(modalRef);
  }

  deleteFaleflex(row: any) {
    Swal.fire({
      title: "Confirmação",
      text: "Deseja excluir este item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: '#161D31',
      cancelButtonColor: '#6e7d88',
      confirmButtonText: 'Confirmar',
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Aguarde",
          text: "Estamos excluindo o item.",
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        Swal.showLoading();
        this.fechamentoService.deleteFechamentoFaleflexItem(row.id_fechamento_faleflex_final).subscribe(
          (res) => {
            Swal.close();
            if (res.statusCode === 200) {
              this.rows_faleflex = this.rows_faleflex.filter((r: any) => r.id_fechamento_faleflex_final !== row.id_fechamento_faleflex_final);
              this.temp_faleflex = this.rows_faleflex;
              Swal.fire({
                title: "Item excluído!",
                text: "O item foi removido com sucesso.",
                icon: "success",
                confirmButtonText: "Ok",
                confirmButtonColor: '#161D31',
              });
            } else {
              this.msgErroInterno();
            }
          },
          (error) => {
            console.error(error);
            Swal.close();
            this.msgErroInterno();
          }
        );
      }
    });
  }

  shareByVeiculo(idCliente: string, idFechamento: string) {
    Swal.fire({
      title: "Confirmação",
      text: "Deseja enviar dados do veículo?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: '#161D31',
      cancelButtonColor: '#6e7d88',
      confirmButtonText: 'Confirmar',
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Aguarde",
          text: "Estamos enviando os dados. Isso pode levar alguns instantes.",
          allowOutsideClick: false,
          allowEscapeKey: false
        });
        Swal.showLoading();

        this.fechamentoService.postEnviarDados(idCliente, idFechamento, 1).subscribe(
          (res) => {
            Swal.close();
            if (res.statusCode === 201) {
              Swal.fire({
                title: "Arquivo enviado!",
                text: "O arquivo foi enviado com sucesso.",
                icon: "success",
                confirmButtonText: "Confirmar",
                confirmButtonColor: '#161D31',
              });
            } else {
              this.msgErroInterno();
            }
          },
          (error) => {
            console.error(error);
            Swal.close();
            this.msgErroInterno();
          }
        );
      }
    });
  }


  shareBychip(idCliente: string, idFechamento: string) {
    Swal.fire({
      title: "Confirmação",
      text: "Deseja enviar dados do Chip?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: '#161D31',
      cancelButtonColor: '#6e7d88',
      confirmButtonText: 'Confirmar',
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Aguarde",
          text: "Estamos enviando os dados. Isso pode levar alguns instantes.",
          allowOutsideClick: false,
          allowEscapeKey: false
        });
        Swal.showLoading(); 

        this.fechamentoService.postEnviarDados(idCliente, idFechamento, 2).subscribe(
          (res) => {
            Swal.close(); 
            if (res.statusCode === 201) {
              Swal.fire({
                title: "Arquivo enviado!",
                text: "O arquivo foi enviado com sucesso.",
                icon: "success",
                confirmButtonText: "Confirmar",
                confirmButtonColor: '#161D31',
              });
            } else {
              this.msgErroInterno();
            }
          },
          (error) => {
            console.error(error);
            Swal.close();
            this.msgErroInterno();
          }
        );
      }
    });
  }

  sendBoletoOneFaleflex(event, param) {
    Swal.fire({
      title: "Confirmação",
      text: "Deseja reenviar boleto?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: '#161D31',
      cancelButtonColor: '#6e7d88',
      confirmButtonText: 'Confirmar',
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Aguarde",
          text: "Estamos reenviando o boleto. Isso pode levar alguns instantes.",
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        Swal.showLoading(); 
  
        this.fechamentoService.postEnviarBoletoFaleflex(this.idCliente, this.idFechamento).subscribe(
          (res) => {
            Swal.close(); 
            console.log(res);
  
            if (res.statusCode === 201) {
              Swal.fire({
                title: "Boleto reenviado!",
                text: "O boleto foi enviado com sucesso.",
                icon: "success",
                confirmButtonText: "Confirmar",
                confirmButtonColor: '#161D31',
              }).then(() => {
                this.spinnerImportarBoleto = false;
              });
            } else {
              this.msgErroInterno();
            }
          },
          (error) => {
            console.log(error);
            Swal.close(); 
            this.spinnerImportarBoleto = false;
            this.msgErroInterno();
          }
        );
      }
    });
  }

  // Rótulo do status de cobrança (flg_chip/flg_veiculos/flg_faleflex): 0=Inativo, 1=Ativo, 3=Cancelado, 4=Bloqueado
  labelCobranca(valor) {
    if (valor == 1) return 'ATIVO';
    if (valor == 0) return 'INATIVO';
    if (valor == 3) return 'CANCELADO';
    if (valor == 4) return 'BLOQUEADO';
    return '-';
  }

  // Baixa o relatório Excel de CDR (Faleflex) do período do fechamento (mês vigente, calculado no backend)
  gerarRelatorioCdrFaleflex() {
    this.spinnerRelatorioCdr = true;
    this.fechamentoService.getRelatorioCdrExcel(this.idCliente, this.idFechamento).subscribe(
      (blob) => {
        this.spinnerRelatorioCdr = false;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `relatorio-cdr-cliente-${this.idCliente}-fechamento-${this.idFechamento}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);
      },
      (error) => {
        console.log(error);
        this.spinnerRelatorioCdr = false;
        Swal.fire({
          title: "Erro!",
          text: "Não foi possível gerar o relatório de CDR.",
          icon: "error",
          confirmButtonText: "Confirmar",
          confirmButtonColor: '#ef6767',
        });
      }
    );
  }

  // Antes de gerar, confere a regra "serviços diferentes do fechamento anterior": o crawler não gera esses clientes;
  // aqui a venda pode ser gerada, mas só depois de o usuário confirmar a diferença.
  sendBoletoFaleflex(event, param) {
    this.fechamentoService.getServicosDiferentesFaleflex(this.idCliente, this.idFechamento).subscribe(
      (res) => this.confirmarVendaFaleflex(res?.data?.servicos_diferentes || null),
      (error) => {
        console.log(error);
        this.confirmarVendaFaleflex(null);
      }
    );
  }

  private confirmarVendaFaleflex(servicosDiferentes: string | null) {
    const confirmacao = servicosDiferentes
      ? {
        title: "Serviços diferentes do fechamento anterior",
        html: `A quantidade de itens deste cliente mudou em relação ao fechamento anterior:<br><b>${servicosDiferentes}</b>.`
          + '<br><br>O crawler não gera este boleto. Confira os itens antes. Deseja gerar a venda mesmo assim?',
        confirmButtonText: 'Gerar mesmo assim',
      }
      : { title: "Confirmação", text: "Deseja gerar venda?", confirmButtonText: 'Confirmar' };
    Swal.fire({
      ...confirmacao,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: '#161D31',
      cancelButtonColor: '#6e7d88',
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Aguarde",
          text: "Estamos gerando a venda. Isso pode levar alguns instantes.",
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        Swal.showLoading(); 
  
        this.fechamentoService.postGerarVendaFaleflex(this.idCliente, this.idFechamento, !!servicosDiferentes).subscribe(
          (res) => {
            Swal.close();
            console.log(res);
  
            if (res.statusCode === 201) {
              Swal.fire({
                title: "Venda gerada!",
                text: "A venda foi gerada com sucesso.",
                icon: "success",
                confirmButtonText: "Confirmar",
                confirmButtonColor: '#161D31',
              }).then(() => {
                this.spinnerImportar = false;
              });
            } else {
              this.msgErroInternoExisting();
            }
          },
          (error) => {
            console.log(error);
            Swal.close(); 
            this.spinnerImportar = false;
            this.msgErroInterno();
          }
        );
      }
    });
  }

}
